import { useEffect, useState } from "react";
import {
  MiBox,
  MiButton,
  MiDetailFields,
  MiDetailPageHeader,
  MiTab,
} from "@miplatform/components";
import {
  BUTTON_COLORS,
  BUTTON_VARIANTS,
  ENTITY_NAMES,
  ISSUE_TEMPLATE_TABS,
  ISSUE_TEMPLATE_TABS_LIST,
} from "@miplatform/constants";
import { useEdit, useRouter } from "@miplatform/hooks";
import { mdiChevronLeft, mdiFormatListBulleted, mdiPlus } from "@mdi/js";
import { Footer } from "@mibuildweb/components";
import { IssueTemplateOrderTemplates } from "./IssueTemplateOrderTemplates";
import { useIssueTemplateDetailsViewModel } from "./useIssueTemplateDetailsViewModel";

export const IssueTemplateDetails = () => {
  const router = useRouter();
  const { id, activeTab } = router.params;

  const [openAddModal, setOpenAddModal] = useState(false);
  const {
    stateManager,
    issueTemplate,
    getIssueTemplate,
    trades,
    getTrades,
    updateIssueTemplate,
    prepareIssueTemplateFields,
    assignmentTemplates,
    getAssignmentTemplates,
  } = useIssueTemplateDetailsViewModel();

  useEffect(() => {
    getIssueTemplate(id);
    getAssignmentTemplates();
    getTrades();
  }, []);
  const issueTemplateFields = prepareIssueTemplateFields({
    assignmentTemplates,
    trades,
  });

  const edit = useEdit(issueTemplate, issueTemplateFields);

  const onUpdate = async () => {
    updateIssueTemplate(id, {
      ...edit.edits,
      modifiedOn: edit.getValue("modifiedOn"),
    });
  };

  const handleTabChange = (tab) => {
    router.navigate(`/settings/order-management/issue-types/${id}/${tab}`);
  };

  const customOnBack = () => {
    router.navigate("/settings/order-management/issue-types");
  };

  return (
    <>
      <MiDetailPageHeader
        title={`${ENTITY_NAMES.ISSUE_TEMPLATE}: ${issueTemplate?.name || ""}`}
        titleIcon={mdiChevronLeft}
        loading={stateManager.isBusy()}
        customOnBack={customOnBack}
        actionComponent={
          activeTab === ISSUE_TEMPLATE_TABS.ORDER_TEMPLATES && (
            <MiButton
              title={`Add ${ENTITY_NAMES.ORDER_TEMPLATE}`}
              variant={BUTTON_VARIANTS.CONTAINED}
              size="medium"
              color={BUTTON_COLORS.PRIMARY}
              startIcon={{
                path: mdiPlus,
                iconSize: 0.8,
              }}
              onClick={() => setOpenAddModal(true)}
              data-testid="Add Product"
            />
          )
        }
      />
      <MiTab
        tabs={ISSUE_TEMPLATE_TABS_LIST}
        currentTab={activeTab}
        onTabChange={handleTabChange}
      />
      <MiBox>
        {activeTab === ISSUE_TEMPLATE_TABS.DETAILS && (
          <MiDetailFields
            detailFields={issueTemplateFields}
            headerProps={{
              icon: mdiFormatListBulleted,
              title: "Detail Fields",
            }}
            edit={edit}
          />
        )}
        {activeTab === ISSUE_TEMPLATE_TABS.ORDER_TEMPLATES && (
          <IssueTemplateOrderTemplates
            issueTemplateId={id}
            stateManager={stateManager}
            openAddModal={openAddModal}
            setOpenAddModal={setOpenAddModal}
          />
        )}
      </MiBox>
      <Footer
        show={edit.isDirty()}
        handleSaveClick={onUpdate}
        handleCancelClick={edit.reset}
        disableSave={!edit.isValid() || stateManager.isBusy()}
      />
    </>
  );
};
